export default {
  primary: "#00AFEF",
  white: "#FFFFFF",
  light: "#E7F5FC",
  backgroundColor: "#FFFFFF",
  placeholder: "#525E6C",
  error: "#b00",
  secondary: "#064B82",
  radius: ".8rem",
  lightBackground: "#d4e7e7",
};
